import React from 'react';
import { motion } from 'framer-motion';
import { Construction, Mail, Clock } from 'lucide-react';

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center p-4">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-blue-400/10 rounded-full blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 text-center max-w-2xl mx-auto"
      >
        {/* Logo */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="mb-8"
        >
          <h1 className="text-3xl sm:text-4xl font-serif font-bold text-white mb-2">
            <span>IL </span>
            <span className="text-blue-400">MIO </span>
            <span>TERAPEUTA</span>
          </h1>
          <p className="text-blue-300 text-sm">Psicoterapia Efficace</p>
        </motion.div>

        {/* Icon */}
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ delay: 0.4, duration: 0.6, type: "spring" }}
          className="w-24 h-24 mx-auto mb-8 rounded-2xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center"
        >
          <Construction className="w-12 h-12 text-blue-400" />
        </motion.div>

        {/* Main message */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="text-2xl sm:text-3xl font-serif font-bold text-white mb-4"
        >
          Stiamo lavorando per voi
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="text-blue-200 text-lg mb-8 leading-relaxed"
        >
          Il nostro sito è attualmente in fase di aggiornamento per offrirti 
          un'esperienza migliore. Torneremo presto online.
        </motion.p>

        {/* Info cards */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.5 }}
          className="flex flex-col sm:flex-row gap-4 justify-center mb-8"
        >
          <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-white/5 border border-white/10">
            <Clock className="w-5 h-5 text-blue-400" />
            <span className="text-white text-sm">Torneremo presto</span>
          </div>
          <a 
            href="mailto:infoilmioterapeuta@gmail.com"
            className="flex items-center gap-3 px-5 py-3 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
          >
            <Mail className="w-5 h-5 text-blue-400" />
            <span className="text-white text-sm">infoilmioterapeuta@gmail.com</span>
          </a>
        </motion.div>

        {/* Footer */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.5 }}
          className="text-blue-300/60 text-sm"
        >
          © 2025 Il Mio Terapeuta - Tutti i diritti riservati
        </motion.p>
      </motion.div>
    </div>
  );
};

export default MaintenancePage;
